module.exports = __webpack_public_path__ + "static/media/view5.5b76d7da.jpg";